import React from "react"

import { splitByChars } from "lib/utils"

import styles from "./FatButton.module.scss"

import DOMPurify from "dompurify";

const MAX_CHAR = 15
interface FatButtonProps {
  onClick?: () => void
  clicked?: boolean
  img?: string
  type?: string
  children: string | JSX.Element
  additionalMentions?: string | JSX.Element
  disabled?: boolean
  doNotFormat?: boolean
  font?: "default" | "medium" | "large" | "xlarge" | "xxxlarge"
  style?: any
  imgStyle?: React.CSSProperties
  size?: "small"
  ui?: {
    buttonStyle?: React.CSSProperties
  }
}

const Span = (props: { children: string }) => {
  const length = props.children.length

  const className = `${styles.Span} ${
    length > MAX_CHAR ? styles.smallSize : styles.inline
  }`
  return <span className={className}>{props.children}</span>
}

const FatButton: React.FC<FatButtonProps> = (props) => {
  const spans =
    typeof props.children === "string"
      ? splitByChars(props.children as string, MAX_CHAR).map(
          (text: string, key: number) => <Span key={key}>{text}</Span>
        )
      : props.children
  const classWrapped = `${styles.FatButton} ${
    props.img ? styles.Pictured : null
  } ${props.clicked ? styles.Clicked : null} ${
    props.type
      ? props.type === "accent"
        ? styles.Accent
        : props.type === "ghost"
        ? styles.Ghost
        : styles.Primary
      : null
  } ${
    props.font ? (props.font === "xlarge" ? styles.XlargeFontSize : null) : null
  } ${props.size === "small" ? styles.Small : null}`
  return (
    <div
      className={classWrapped}
      onClick={() =>
        !props.disabled && props.onClick ? props.onClick() : undefined
      }
      data-testid="FatButton"
      style={props.style}
    >
      {props.img ? <img src={props.img} style={{ objectFit: "contain", ...props.imgStyle }} alt="" /> : null}
      {props.doNotFormat ? (
        typeof props.children === "string" ? (
          <div style={{ marginTop: props?.additionalMentions && '15px', ...props.ui?.buttonStyle}}>
            <span
              style={{
                width: "100%",
                lineHeight: "37px",
                textOverflow: "ellipsis",
                overflow: "hidden",
                color: props.disabled ? '#7A7A7A' : 'inherit'
              }}
              dangerouslySetInnerHTML={{
                __html: (DOMPurify.sanitize(props.children as any, { USE_PROFILES: { html: true }}) as string) || "",
              }}
            />
            <span>{props.additionalMentions && (props.additionalMentions)}</span>
          </div>
        ) : (
          <span>{props.children}</span>
        )
      ) : (
        spans
      )}
    </div>
  )
}

export default FatButton
